var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { observable, action, computed, makeObservable, } from "mobx";
import { makePersistable } from "mobx-persist-store";
import config from "@/config";
import { MixpanelEvents } from "@/utilities/mixpanel/events";
var ListState = /** @class */ (function () {
    function ListState(_a) {
        var limit = _a.limit, processingData = _a.processingData, apiDataInitial = _a.apiDataInitial, searchFields = _a.searchFields, sortFields = _a.sortFields, withoutAppId = _a.withoutAppId, filtersLoadSave = _a.filtersLoadSave;
        var _this = this;
        this.pending = false;
        this.searchInputValue = "";
        this.searchMode = "q";
        this.isListPopupShowed = false;
        this.pickedListElements = [];
        this.latestSearches = [];
        this.loadingChannels = true;
        this.changeIsDense = function (dense) {
            _this.dense = dense;
        };
        this.changeHiddenColumns = function (columnsIds) {
            _this.hiddenColumns = columnsIds;
        };
        this.changeColumnsOrder = function (columnsIds) {
            _this.columnsOrder = columnsIds;
        };
        this.onPageClick = function (page) {
            _this.currentPage = page;
        };
        this.onRowClick = function (id) {
            _this.showListPopup();
            _this.setCurrentPickedRow(id);
        };
        this.setCurrentPickedRow = function (id) {
            _this.currentPickedRow = id;
        };
        this.showListPopup = function () {
            _this.isListPopupShowed = true;
        };
        this.hideListPopup = function () {
            _this.isListPopupShowed = false;
        };
        this.handlePrevButtonClick = function () {
            _this.currentPage = _this.currentPage - 1;
        };
        this.handleNextButtonClick = function () {
            _this.currentPage = _this.currentPage + 1;
        };
        this.removeDecreeseSign = function (value) {
            return (value === null || value === void 0 ? void 0 : value.startsWith("-")) ? value.slice(1) : value;
        };
        this.sortColumn = function (columnName) {
            var sortFromLowest = "-".concat(columnName);
            var sortFromBiggest = columnName;
            if (_this.sortFields.includes(sortFromLowest)) {
                _this.removeSortingType(sortFromLowest);
                _this.addSortingType(sortFromBiggest);
            }
            else if (_this.sortFields.includes(sortFromBiggest)) {
                _this.removeSortingType(sortFromBiggest);
                _this.addSortingType(sortFromLowest);
            }
            else {
                _this.sortFields = [];
                _this.addSortingType(sortFromLowest);
            }
            _this.resetPaging();
        };
        this.onCheckboxClick = function (pickedId) {
            if (_this.pickedListElements.includes(pickedId)) {
                _this.pickedListElements = _this.pickedListElements.filter(function (id) { return id !== pickedId; });
            }
            else {
                _this.pickedListElements.push(pickedId);
            }
        };
        this.removeAllSorting = function () {
            _this.sortFields.length = 0;
        };
        this.removeFilters = function () {
            _this.filters = {};
        };
        this.removeSortingType = function (sortingType) {
            _this.sortFields = _this.sortFields.filter(function (sort) { return sort !== sortingType; });
        };
        this.addSortingType = function (sortingType) {
            _this.sortFields.push(sortingType);
        };
        this.resetPaging = function () {
            _this.currentPage = 1;
        };
        this.handleClearSearchInput = function () {
            _this.searchInputValue = "";
            _this.filters = {};
        };
        this.changeAllSearchableFields = function (inputValue) {
            var e_1, _a;
            try {
                for (var _b = __values(_this.searchFields), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var searchableField = _c.value;
                    if (inputValue) {
                        _this.filters[searchableField] = { like: inputValue };
                    }
                    else {
                        delete _this.filters[searchableField];
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
        this.handleDefaultSearchInput = function (event) {
            var value = event.target.value;
            //used to block input of special characters if value contains only numbers
            // seems to have been a desired feeture but is currently being disabled according to https://360dialog.atlassian.net/browse/HUB-1981 to remove such restriction
            // if (value.match(this.doesNotHaveLetters)) {
            //   value = value.replace(this.isNotNumbers, "");
            // }
            _this.searchInputValue = value;
            _this.changeAllSearchableFields(value);
            _this.resetPaging();
        };
        this.changeLatestSearches = function (value) {
            _this.latestSearches = value;
        };
        this.apiDataInitial = apiDataInitial;
        this.limit = limit;
        this.filters = {};
        this.filtersLoadSave = filtersLoadSave || null;
        this.processingData = processingData || undefined;
        this.currentPage = 1;
        this.searchFields = searchFields || ["name"];
        this.sortFields = sortFields || [];
        this.withoutAppId = withoutAppId;
        this.initialQueryParams = {
            sort: sortFields || [],
            offset: 0,
            limit: limit,
            filters: {},
        };
        this.doesNotHaveLetters = /^[^a-zA-Z]+$/;
        this.isNotNumbers = /[^0-9]+/gi;
        this.dense = false;
        this.hiddenColumns = [];
        this.columnsOrder = [];
        this.partnerId = null;
        if (apiDataInitial) {
            this.APIData = apiDataInitial;
        }
        makeObservable(this, {
            filters: observable,
            sortFields: observable,
            pending: observable,
            searchInputValue: observable,
            isListPopupShowed: observable,
            APIData: observable,
            currentPage: observable,
            searchFields: observable,
            pickedListElements: observable,
            dense: observable,
            columnsOrder: observable,
            hiddenColumns: observable,
            latestSearches: observable,
            offset: computed,
            listPages: computed,
            allQueryParams: computed,
            computedFilters: computed,
            onPageClick: action,
            onRowClick: action,
            setCurrentPickedRow: action,
            showListPopup: action,
            hideListPopup: action,
            handlePrevButtonClick: action,
            handleNextButtonClick: action,
            removeDecreeseSign: action,
            sortColumn: action,
            onCheckboxClick: action,
            removeAllSorting: action,
            addSortingType: action,
            handleClearSearchInput: action,
            handleDefaultSearchInput: action,
            insertListData: action,
            changeIsDense: action,
            changeHiddenColumns: action,
            changeColumnsOrder: action,
            changeLatestSearches: action,
        });
    }
    Object.defineProperty(ListState.prototype, "computedFilters", {
        get: function () {
            var filters = __assign({}, this.filters);
            if (this.searchMode === "q") {
                // Remove field-specific search key if present
                if (this.searchField) {
                    delete filters[this.searchField];
                }
                if (this.searchInputValue) {
                    filters.q = this.searchInputValue;
                }
                else {
                    delete filters.q;
                }
            }
            else if (this.searchMode === "field" && this.searchField) {
                // Remove q if present
                delete filters.q;
                if (this.searchInputValue) {
                    filters[this.searchField] = { like: this.searchInputValue };
                }
                else {
                    delete filters[this.searchField];
                }
            }
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    ListState.prototype.debounce = function (callback, wait) {
        var _this = this;
        var timeout;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = _this;
            clearTimeout(timeout);
            timeout = setTimeout(function () { return callback.apply(context, args); }, wait);
        };
    };
    Object.defineProperty(ListState.prototype, "offset", {
        get: function () {
            return (this.currentPage - 1) * this.limit;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ListState.prototype, "listPages", {
        get: function () {
            var total = this.APIData.total;
            var limit = this.limit;
            var totalNumbers = Math.floor(total / limit) + (total % limit !== 0 ? 1 : 0);
            return totalNumbers;
        },
        enumerable: false,
        configurable: true
    });
    ListState.prototype.insertListData = function (listData) {
        this.APIData = listData;
        this.loadingChannels = false;
    };
    ListState.prototype.updateLoadingState = function (isLoading) {
        this.loadingChannels = isLoading;
    };
    Object.defineProperty(ListState.prototype, "allQueryParams", {
        get: function () {
            return {
                sort: this.sortFields,
                offset: this.offset,
                filters: this.filters,
                limit: this.limit,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ListState.prototype, "computedQueryParams", {
        get: function () {
            return {
                sort: this.sortFields,
                offset: this.offset,
                filters: this.computedFilters,
                limit: this.limit,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ListState.prototype, "allQueryParamsPaginationInvoice", {
        get: function () {
            //TODO: check again after backend changes to invoice endpoint
            return {
                page: this.currentPage,
                limit: this.limit,
                sortBy: this.sortFields,
                sortOrder: this.sortOrder,
            };
        },
        enumerable: false,
        configurable: true
    });
    return ListState;
}());
export { ListState };
var AbstractListStateManager = /** @class */ (function () {
    function AbstractListStateManager(params, tableName) {
        var _this = this;
        this.toggleSorting = function () {
            _this.listState.sortColumn(_this.listState.removeDecreeseSign(_this.listState.sortFields[0]));
        };
        this.handleClearSearchInput = function () {
            _this.listState.searchInputValue = "";
            _this.listState.pending = true;
        };
        this.handleDefaultSearchInput = function (event, indicatePending) {
            if (indicatePending === void 0) { indicatePending = true; }
            var value = event.target.value;
            _this.listState.searchInputValue = value;
            _this.listState.resetPaging();
            _this.listState.pending = indicatePending;
        };
        this.changeSearchInputValue = function (value, indicatePending) {
            if (indicatePending === void 0) { indicatePending = true; }
            if (_this.listState.searchInputValue !== value) {
                _this.listState.pending = indicatePending;
            }
            _this.listState.searchInputValue = value;
            _this.listState.resetPaging();
        };
        this.changeFilterByStatusValue = function (object) {
            if (object.status.eq === "all statuses") {
                delete _this.listState.filters.status;
            }
            else {
                var _a = __read(Object.entries(object)[0], 2), key = _a[0], value = _a[1];
                _this.listState.filters[key] = value;
            }
            _this.listState.resetPaging();
        };
        this.changeColumnsOrder = function (columnsIds) {
            _this.listState.changeColumnsOrder(columnsIds);
            MixpanelEvents.tableColumnReordered({ tableName: _this.tableName });
        };
        this.changeHiddenColumns = function (columnsIds) {
            var previousColumns = new Set(_this.listState.hiddenColumns);
            var newColumns = new Set(columnsIds);
            var removed = __spreadArray([], __read(newColumns), false).find(function (col) { return !previousColumns.has(col); });
            var added = __spreadArray([], __read(previousColumns), false).find(function (col) { return !newColumns.has(col); });
            _this.listState.changeHiddenColumns(columnsIds);
            MixpanelEvents.tableColumnDisplayChanged({
                tableName: _this.tableName,
                tableColumn: added || removed,
                displayAction: added ? "show" : "hide",
            });
        };
        this.changeFilters = function (filters) {
            var previousFilters = new Set(Object.keys(_this.listState.filters));
            var newFilters = new Set(Object.keys(filters));
            var addedFilter = __spreadArray([], __read(newFilters), false).find(function (key) { return !previousFilters.has(key); });
            _this.listState.filters = filters;
            if (addedFilter) {
                MixpanelEvents.tableFieldFiltered({
                    tableName: _this.tableName,
                    tableColumn: addedFilter,
                });
            }
        };
        this.changeSorting = function (sortField, direction) {
            if (!sortField)
                return;
            if (direction === null) {
                _this.listState.sortFields = [];
                return;
            }
            _this.listState.sortFields =
                direction === "desc" ? ["-".concat(sortField)] : [sortField];
            MixpanelEvents.tableFieldSorted({
                tableName: _this.tableName,
                tableColumn: sortField,
            });
        };
        this.listState = new ListState(params);
        this.tableName = tableName;
        makeObservable(this, {
            listState: observable,
            APIData: computed,
            toggleSorting: action,
            handleClearSearchInput: action,
            handleDefaultSearchInput: action,
            changeSearchInputValue: action,
            changeFilterByStatusValue: action,
        });
        void makePersistable(this.listState, {
            name: "".concat(config.localStoragePrefixMP, ".").concat(tableName),
            properties: [
                "filters",
                "sortFields",
                "searchFields",
                "sortOrder",
                "columnsOrder",
                "hiddenColumns",
                "dense",
                "partnerId",
                "latestSearches",
                "searchInputValue",
            ],
            storage: localStorage,
        });
    }
    Object.defineProperty(AbstractListStateManager.prototype, "APIData", {
        get: function () {
            return this.listState.APIData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractListStateManager.prototype, "loadingChannels", {
        get: function () {
            return this.listState.loadingChannels;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractListStateManager.prototype, "tableState", {
        get: function () {
            var _a, _b;
            return {
                sortState: {
                    sortField: (_a = this.listState.sortFields[0]) === null || _a === void 0 ? void 0 : _a.replace("-", ""),
                    direction: ((_b = this.listState.sortFields[0]) === null || _b === void 0 ? void 0 : _b.includes("-")) ? "desc" : "asc",
                },
                searchInput: this.listState.searchInputValue,
                dense: this.listState.dense,
                filters: this.filters,
                columnsOrder: this.listState.columnsOrder,
                hiddenColumns: this.listState.hiddenColumns,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractListStateManager.prototype, "filters", {
        get: function () {
            return JSON.parse(JSON.stringify(this.listState.filters));
        },
        enumerable: false,
        configurable: true
    });
    return AbstractListStateManager;
}());
var PipesListState = /** @class */ (function (_super) {
    __extends(PipesListState, _super);
    function PipesListState(params) {
        return _super.call(this, params, "partner_wabas") || this;
    }
    return PipesListState;
}(AbstractListStateManager));
export { PipesListState };
var InvoicesListState = /** @class */ (function (_super) {
    __extends(InvoicesListState, _super);
    function InvoicesListState(params) {
        return _super.call(this, params, "partner_invoices") || this;
    }
    return InvoicesListState;
}(AbstractListStateManager));
export { InvoicesListState };
//# sourceMappingURL=data:application/json;base64,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